export default __webpack_public_path__ + "static/media/1.db96df6f.png";